import { localizationEnUsDelivery, routerPageDelivery } from "./delivery";

import {
  localizationEnUsSubscriptions,
  routerPageSubscriptions,
} from "./subscriptions";
import { localizationEnUsHardware, routerPageHardware } from "./hardware";
import {
  localizationEnUsSubscription,
  routerPageSubscription,
} from "./subscription";

export const localizationEnUsProducts = {
  ...localizationEnUsDelivery,
  ...localizationEnUsSubscriptions,
  ...localizationEnUsHardware,
  ...localizationEnUsSubscription,
};

export const routersPageProducts = [
  routerPageDelivery,
  routerPageSubscriptions,
  routerPageHardware,
  routerPageSubscription,
];
